module.exports = __webpack_public_path__ + "static/media/eecs_logo.0ebad29c.jpg";